import {
  getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationFetcher,
  getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * トップバナー更新APIを実行するカスタムフック
 *
 * @param threeLetterCode - パートナーコード
 * @param topBannerId - トップバナーID
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePutPartnerAdminsTopBanner = (
  threeLetterCode: string,
  topBannerId: number,
  options?: {
    onSuccess?: (data: PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationKey(threeLetterCode, topBannerId),
    getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationFetcher(
      threeLetterCode,
      topBannerId
    ),
    options
  );
};
